(function () {
  if (!matchMedia('(max-width: 749px)').matches) return;
    var EXTRA_BETAAL = {
    afterpay: '<svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-afterpay"><title id="pi-afterpay">Afterpay</title>' +
      '<rect width="38" height="24" rx="3" fill="#b2fce4"/><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"/>' +
      '<text x="19" y="14.6" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-weight="700" font-size="7.4" letter-spacing="-.1" fill="#000">afterpay</text></svg>',
    paypal: '<svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-paypal"><title id="pi-paypal">PayPal</title>' +
      '<rect width="38" height="24" rx="3" fill="#fff"/><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"/>' +
      '<text x="19" y="15" text-anchor="middle" font-family="Verdana, Arial, Helvetica, sans-serif" font-weight="700" font-style="italic" font-size="8.2" letter-spacing="-.2"><tspan fill="#003087">Pay</tspan><tspan fill="#009cde">Pal</tspan></text></svg>'
  };
  var VOLGORDE = ['afterpay', 'paypal', 'visa', 'shopify_pay', 'master', 'apple_pay', 'google_pay'];
  function sleutel(el) {
    var svg = el.matches && el.matches('svg[aria-labelledby^="pi-"]') ? el : el.querySelector && el.querySelector('svg[aria-labelledby^="pi-"]');
    return svg ? svg.getAttribute('aria-labelledby').slice(3) : '';
  }
  function betaalIconen() {
    document.querySelectorAll('.product__info-container .obis-payment-icons').forEach(function (box) {
      var voorbeeld = box.firstElementChild;
      ['afterpay', 'paypal'].forEach(function (k) {
        if (box.querySelector('[aria-labelledby="pi-' + k + '"]')) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = EXTRA_BETAAL[k];
        var svg = tmp.firstElementChild;
        if (voorbeeld && voorbeeld.tagName !== 'svg' && voorbeeld.tagName !== 'SVG') {
          var wrap = voorbeeld.cloneNode(false);
          wrap.appendChild(svg);
          box.appendChild(wrap);
        } else {
          box.appendChild(svg);
        }
      });
      var items = [].slice.call(box.children);
      var juist = VOLGORDE.map(function (k) { return items.filter(function (el) { return sleutel(el) === k; })[0]; }).filter(Boolean);
      items.forEach(function (el) { if (juist.indexOf(el) < 0 && el.style.display !== 'none') el.style.display = 'none'; });
      var nu = items.filter(function (el) { return juist.indexOf(el) >= 0; });
      if (juist.every(function (el, i) { return nu[i] === el; })) return;
      juist.forEach(function (el) { box.appendChild(el); });
    });
  }
    function ster(vul, id) {
    return '<svg viewBox="0 0 20 20" aria-hidden="true"><defs><linearGradient id="' + id + '"><stop offset="' + vul + '" stop-color="#c4a668"/><stop offset="' + vul + '" stop-color="#d6d6de"/></linearGradient></defs>' +
      '<path fill="url(#' + id + ')" d="M10 1.3l2.6 5.5 6 .7-4.4 4.1 1.2 5.9L10 14.6l-5.4 2.9 1.2-5.9L1.4 7.5l6-.7z"/></svg>';
  }
  function sterren() {
    document.querySelectorAll('.product__info-container > .product__title').forEach(function (t) {
      var prev = t.previousElementSibling;
      if (prev && prev.classList.contains('ob-rating')) return;
      var el = document.createElement('div');
      el.className = 'ob-rating';
      el.innerHTML = '<span class="ob-rating__stars" aria-label="4.7 / 5">' + ster(1, 'obs1') + ster(1, 'obs2') + ster(1, 'obs3') + ster(1, 'obs4') + ster(0.7, 'obs5') +
        '</span><span><b>4.7/5</b> (1939 Reviews)</span>';
      t.insertAdjacentElement('beforebegin', el);
    });
  }
      var UPS = '<svg class="ob-ups" viewBox="0 0 40 46" aria-hidden="true">' +
    '<path d="M20 1C12 1 6 2.2 2 4v20c0 10 7.5 16 18 21 10.5-5 18-11 18-21V4C34 2.2 28 1 20 1z" fill="#ffb500"/>' +
    '<path d="M20 2.9C12.6 2.9 7 4 3.7 5.5V24c0 9 6.7 14.4 16.3 19 9.6-4.6 16.3-10 16.3-19V5.5C33 4 27.4 2.9 20 2.9z" fill="#4b2410"/>' +
    '<path d="M3.7 10.6C9 7.4 16.2 5.7 24.6 5.7c4.3 0 8.4.4 11.7 1.1V5.5C33 4 27.4 2.9 20 2.9 12.6 2.9 7 4 3.7 5.5z" fill="#ffb500"/>' +
    '<text x="20.2" y="31.5" text-anchor="middle" font-family="Arial Narrow, Arial, Helvetica, sans-serif" font-weight="700" font-size="25" textLength="28.5" lengthAdjust="spacingAndGlyphs" fill="#ffb500">ups</text>' +
    '</svg>';
  var RETOUR = '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false"><path d="M22 44a29 29 0 0 1 52-15"/><path d="M76 13v16H60"/><path d="M78 56a29 29 0 0 1-52 15"/><path d="M24 87V71h16"/></svg>';
  var TAS = '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false"><path d="M22 34h56l-5 54H27z"/><path d="M38 34v-7a12 12 0 0 1 24 0v7"/><path d="M41 74l18-22"/><circle cx="42" cy="54" r="4"/><circle cx="58" cy="72" r="4"/></svg>';
  var USP = [
    { icoon: UPS, tekst: 'Free Shipping with UPS' },
    { icoon: RETOUR, tekst: '30 Day Returns' },
    { icoon: TAS, tekst: 'Buy 2, get an extra 10% off' }
  ];
  function usps() {
    var rijen = document.querySelectorAll('.product__info-container > .cx-promos > .cx-promos__row');
    [].forEach.call(rijen, function (rij, i) {
      var u = USP[i];
      if (!u || rij.classList.contains('ob-usp')) return;
      rij.classList.add('ob-usp');
      rij.querySelector('.cx-promos__icon').innerHTML = u.icoon;
      if (u.tekst) rij.querySelector('.cx-promos__text').textContent = u.tekst;
    });
  }
    function gekocht() {
    var pf = document.querySelector('.product__info-container > div > product-form');
    if (!pf) return;
    var blok = pf.parentElement;
    var prev = blok.previousElementSibling;
    if (prev && prev.classList.contains('ob-bought')) return;
    var oud = document.querySelector('.product__info-container > .ob-bought');
    var el = oud || document.createElement('p');
    if (!oud) {
      el.className = 'ob-bought';
      el.innerHTML = '<span class="ob-bought__dot" aria-hidden="true"></span><span>100+ bought in the last 7 days</span>';
    }
    blok.insertAdjacentElement('beforebegin', el);
  }
    function saleMelding() {
    var pay = document.querySelector('.product__info-container .obis-payment-icons');
    if (!pay) return;
    var blok = pay;
    while (blok.parentElement && !blok.parentElement.classList.contains('product__info-container')) blok = blok.parentElement;
    var next = blok.nextElementSibling;
    if (next && next.classList.contains('ob-sale-note')) return;
    var el = document.createElement('div');
    el.className = 'ob-sale-note';
    el.innerHTML = '<b>FALL SALE UPDATE:</b> Due to high demand during our fall sale, only a limited number of items are left. ' +
      'If you can still click <b>\'Add to cart\'</b>, it\u2019s still available.';
    blok.insertAdjacentElement('afterend', el);
  }
    function bedrag(el) { return el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) : NaN; }
  function saveLabel() {
    document.querySelectorAll('.product__info-container .price--on-sale').forEach(function (pr) {
      var b = pr.querySelector('.price__badge-sale');
      if (!b) return;
      var oud = bedrag(pr.querySelector('.price__sale .price-item--regular'));
      var nu = bedrag(pr.querySelector('.price__sale .price-item--sale'));
      var pct = oud > nu ? Math.round((1 - nu / oud) * 100) : 0;
      var tekst = pct ? 'SAVE ' + pct + '%' : 'SALE';
      if (!b.classList.contains('ob-save')) b.classList.add('ob-save');
      if (b.textContent.trim() !== tekst) b.textContent = tekst;
    });
  }
    var BALK = 'EARLY BLACK FRIDAY SALE - UP TO 50% OFF!';
  function balkOnderLogo() {
    document.querySelectorAll('[id$="__announcement_bar_2"] .announcement-bar__message').forEach(function (m) {
      var doel = m.querySelector('span') || m;
      if (doel.textContent !== BALK) doel.textContent = BALK;
    });
  }
  function alles() { if (document.documentElement.getAttribute('data-ab-mpdp-obis') !== 'b') return; betaalIconen(); sterren(); usps(); gekocht(); saleMelding(); saveLabel(); balkOnderLogo(); }
  alles();
  new MutationObserver(alles).observe(document.body, { childList: true, subtree: true });
})();
